import { render, staticRenderFns } from "./testingSwitchInput.vue?vue&type=template&id=03860078&"
import script from "./testingSwitchInput.vue?vue&type=script&lang=js&"
export * from "./testingSwitchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports